import React, { FC } from 'react';
import styles from './ChopDescription.module.css';

const ChopDescription: FC = () => {
  return (
    <div className='w-full mt-8 sm:mt-12 lg:mt-20'>
      <div className={`body-paragraph mx-auto ${styles['max-w-paragraph']}`}>
        The Church Online Platform is a free tool from Life.Church that allows you to create an
        engaging online service for your attenders.
      </div>
    </div>
  );
};

export default ChopDescription;
